var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty_box"},[_c('div',{staticClass:"empty_cont"},[_c('p',{staticClass:"img"},[_c('img',{attrs:{"src":require("@/assets/empty_icon.png"),"alt":""}})]),_c('p',{staticClass:"empty_text"},[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }